/* eslint-disable max-lines */
import { type TUser } from '@packages/utils/types'
import { get } from 'svelte/store'
import { accessTokenStore, userStore, isLoggedInStore, isLoggingInProcessStore } from '@packages/stores'
import { PassportLocalStorage } from '@packages/utils/enums'
import { analytics } from '@lib/mixpanel/mixpanel'
import { sdk } from '@lib/sdk/sdk'
import { getUser } from '@src/passport/user'
import { getAddress } from '@src/passport/blockchain'
import { configStore } from '@src/stores/config'

export const retrieveCredenzaAccess = async () => {
  try {
    isLoggingInProcessStore.set(true)
    const config = get(configStore)

    const currentUserAddress = await getAddress()
    const accessToken = sdk.getAccessToken()
    accessTokenStore.set(accessToken)

    const user: TUser = await getUser()
    userStore.set(user)
    isLoggedInStore.set(true)
    isLoggingInProcessStore.set(false)

    analytics.identify(user.sub)
    analytics.people.set({
      $email: user.email,
      $phone: user.phone,
      $name: user.name,
      suiNetwork: config.suiNetwork,
      address: currentUserAddress,
      location: window.location.href,
    })
    analytics.track('cp_init', {
      $email: user.email,
      $phone: user.phone,
      suiNetwork: config.suiNetwork,
      clientId: config.clientId,
      address: currentUserAddress,
      location: window.location.href,
    })
  } catch (err) {
    localStorage.removeItem(PassportLocalStorage.ACCESS_TOKEN)
    isLoggedInStore.set(false)
    isLoggingInProcessStore.set(false)
    userStore.set(null)
    accessTokenStore.set(null)
    console.error('Cannot init credenza user', err)
  }
}

export const getUserAddressBySub = async (sub: string): Promise<{ address: string }> => {
  const accessToken = get(accessTokenStore)
  if (!accessToken) throw new Error("Passport access token doesn't exist.")
  const config = get(configStore)

  const result = await fetch(`${config.credenza.suiApiUrl}/accounts/${sub}/assigned-address`, {
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${get(accessTokenStore)}`,
    },
  })

  const json = await result.json()
  if (!result.ok) throw new Error(json.error)

  return json
}
